/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInLimitEntry } from './linkedInLimitEntry';
import type { LinkedInLimitsResponseAccountType } from './linkedInLimitsResponseAccountType';

/**
 * Tier-aware LinkedIn safe-usage education payload.
 *
 * Returns the connected account's ``account_type`` plus the per-action
 * recommended limits + notes for that tier (derived from the static
 * ``LIMITS`` table). Informational only — never an enforcement signal.
 */
export interface LinkedInLimitsResponse {
  account_type: LinkedInLimitsResponseAccountType;
  limits: LinkedInLimitEntry[];
}
